export const SYSTEM_NOTIFICATIONS_PERMISSION_USER_GESTURE_PROMPT_TOAST_KEY =
  'system-notifications-permission-user-gesture-prompt';
